module.exports = __webpack_public_path__ + "static/media/IconoInstrumento.3ec2bbfb.png";